import { ThemeOptions } from "@mui/material";
import { TAppreanceCode } from "../store/slices/configurations";
import { authApi } from "./auth.service";
import { TTheme } from "../models/theme";

const URL = process.env.REACT_APP_APP;

const getFaviconEl = () => {
  return document.getElementById("favicon") as HTMLLinkElement;
};

export const setFavicon = (link: string) => {
  const favicon = getFaviconEl();
  if (favicon) {
    favicon.href = link;
  }
};

const getTitleEl = () => {
  return document.getElementById("title");
};

export const setTitle = (title: string) => {
  const titleEl = getTitleEl();
  if (titleEl) {
    titleEl.innerText = title;
  }
};

export const controlMode = (
  { palette, ...options }: TTheme & ThemeOptions,
  mode: TAppreanceCode
): ThemeOptions => {
  if (mode !== "1" && mode !== "2") {
    throw new Error("Invalid mode. Please provide '1' or '2'.");
  }

  if (options.darkPalette && mode === "2") {
    palette = {
      ...options.darkPalette,
    };
  }

  const optsWithMode: ThemeOptions = {
    ...options,
    palette: {
      ...palette,
      mode: mode === "1" ? "light" : "dark",
    },
  };

  return optsWithMode;
};

/** Serviço de Tickets do 4uChat vinculado ao site. */
interface IChatTicketService {
  id: string;
  name: string | null;
}

interface ISiteApp {
  id: string;
  frontConfig: string;
  /** Modo de abertura do chat definido no site. Fonte da verdade desde o P3396;
      o serviço de tickets também expõe a flag, mas ela é a configuração antiga. */
  fullScreenMode?: boolean;
  /** Serviço de Tickets do 4uChat do site. null = site sem chat. */
  chatTicketServiceId?: string | null;
  chatTicketService?: IChatTicketService | null;
  chatTitle?: string | null;
  chatSubtitle?: string | null;
  chatBotName?: string | null;
  chatWidth?: number | null;
  chatHeight?: number | null;
  chatLogoUrl?: string | null;
  chatBotAvatarUrl?: string | null;
}
interface IGetSiteAppConfig {
  id: string;
  domain: string;
  siteApp: ISiteApp;
}

export const getSiteAppConfig = () => {
  return authApi.get<IGetSiteAppConfig>(URL + "/api/v1/SiteApp");
};
